import React from 'react'
import { useIntl } from 'react-intl'
import { useSelector } from 'react-redux'

import { UserOutlined } from '@ant-design/icons'
import { Avatar, Typography, Divider, Space, Button } from 'antd'
import PropTypes from 'prop-types'

import LanguageSelector from 'components/Layout/Header/Components/LanguageSelector'
import SignOut from 'components/Layout/Header/Components/SignOut'
import ThemeSwitcher from 'components/Layout/Header/Components/ThemeSwitcher'

const { Text } = Typography

const DesktopProfileContent = ({ setVisible, setPopoverVisible }) => {
  const intl = useIntl()
  const userProfile = useSelector(state => state.user.profile)

  const handleEditProfile = () => {
    setVisible(true)
    setPopoverVisible(false)
  }

  return (
    <Space direction="vertical" style={{ padding: 2, width: 250 }}>
      <Space align="center">
        <Avatar
          size="large"
          src={userProfile?.usu_foto || '/styles/img/avatars/avatar.png'}
        />
        <div>
          <Text strong>{userProfile.usu_nome}</Text>
          <br />
          <Text type="secondary" style={{ fontSize: 12, margin: 0 }}>
            {userProfile.usu_login}
          </Text>
        </div>
      </Space>

      <Divider style={{ margin: '4px 0' }} />

      <div style={{ width: '100%' }}>
        <Button
          block
          type="text"
          icon={<UserOutlined />}
          onClick={handleEditProfile}
          style={{
            width: '100%',
            margin: 0,
            paddingLeft: 4,
            textAlign: 'left',
          }}
        >
          <span
            style={{
              marginLeft: '6px',
            }}
          >
            {intl.formatMessage({
              id: 'global.labels.editProfile',
            })}
          </span>
        </Button>

        <ThemeSwitcher />

        <LanguageSelector />
      </div>

      <Divider style={{ margin: '4px 0' }} />

      <SignOut />
    </Space>
  )
}

DesktopProfileContent.defaultProps = {
  setVisible: () => {},
  setPopoverVisible: () => {},
}

DesktopProfileContent.propTypes = {
  setVisible: PropTypes.func,
  setPopoverVisible: PropTypes.func,
}

export default DesktopProfileContent
